import React from "react";
import { TextField, FormControlLabel, Checkbox } from "@mui/material";

const CakeKeywordsFeatured = ({ formData, onChange }) => (
  <>
    <TextField
      label="Keywords (comma separated)"
      name="keywords"
      fullWidth
      margin="dense"
      value={formData.keywords}
      onChange={onChange}
    />
    <FormControlLabel
      control={
        <Checkbox
          name="isFeatured"
          checked={formData.isFeatured}
          onChange={onChange}
        />
      }
      label="Featured Cake"
    />
  </>
);

export default CakeKeywordsFeatured;
